<template>
  <section id="wrapper" class="login-register login-sidebar" style="padding-top: 6%">


            <div class="login-box card"  v-if="mode=='signin'">
              <div class="card-body">
                  <div class="text-center">
                     <img src="../../assets/images/logo-simantap.png" width="150"  alt="logo"  />
                   </div>
                <div class="p-2 mt-3">
                  

                  <h3 class="text-center"> SIMANTAP - <span style="color:#ff9900">BOGORKAB</span>  </h3>

                 
                  <p>Silakan masukkan username & password untuk login ke Aplikasi</p>
                  <div class="form-signin">
                    <div class="form-group">
                      <input
                        type="email"
                        v-model="form.email"
                        id="inputEmail"
                        class="form-control mb-3"
                        name="email"
                        placeholder="Nomor Induk Pegawai"
                        required
                        autofocus
                      />
                    </div>
                    <div class="form-group mb-3">
                      <input
                        type="password"
                         v-model="form.password"
                        id="inputPassword"
                        name="password"
                        class="form-control"
                        placeholder="Kata Sandi"
                        required
                      />
                    </div>
                    <div class="text-left mt-1">
                      <div class="row">
                        <div class="col-md-6">
                          <button class="btn btn-success" style="font-size: 11px;" type="submit" @click="doLogin">
                            Masuk Ke Aplikasi
                          </button>
                        </div>
                        <div class="col-md-6 text-right pt-2" >
                            <span style="font-size:10px;" class="text-right">
                        Lupa password ? klik disini 
                     
                     </span>
                        </div>
                        </div>  
                    </div>
                    
                     <center class="mt-3">
                      Digital Signature By:
                      <img src="../../assets/images/logo-bsre.png" width="100" />
                      
                    </center>
                    
                  </div>
                </div>
              </div>
            </div>
     

     <div class="login-box card" style="border-radius: 0; border:none;" v-if="mode=='signup'">
       
     </div>
  </section>
</template>

<script>
import {  mutations } from "vuex";    
import axios from "axios";
import store from '../../store'
export default {
    data() {
        
        return {
            mode : 'signin' ,
            form : {
                email: '',
                password : ''
            } ,
            reg : {
                username    : '',
                first_name    : '',
                last_name    : '',
                email       : '',
                password    : '',
                password_confirmation    : ''
            },
            loading : false  ,
            counter: 0   
        }
    },
    methods: {
         doLogin(elm) {
           elm.preventDefault()
           

            this.loading = true;
            var config = { 
                headers: { 
                  'Content-Type': 'application/json' ,
                }
            };       
            axios.post( store.state.baseUrl +'user/sso?app=simantap',this.form, config )
           .then(response => {
              //  console.log(response.data)
                if(response.data.status =='error') {
                    this.counter++
                    this.$swal( response.data.message)
                    this.loading = false;
                } else {
                   //  console.log(  data : response.data.data)
                    const  payload =  { data : response.data.data , token :  response.data.token }
                    this.$store.commit('setLoginState', payload)
                    localStorage.setItem('token',response.data.token )
                    localStorage.setItem('profile', JSON.stringify(response.data.data ))
                    this.$router.push('/dashboard')
                }

               
            })
            .catch((error) => {
                alert( error )
            }) 

            
        },
        doRegister(elm){
            elm.preventDefault()
            this.loading = true;
              var config = {
                  headers: { 
                   'Content-Type': 'application/json'
                  }
              };
              axios.post( store.state.baseUrl +'user/register',  this.reg  , config)
             .then(response => {

                  if(response.data.status =='error') {
                    console.log( JSON.parse(response.data.message) ) 

                    this.$bvToast.toast( response.data.message   , {
                        title: 'Ops , Something goes wrong',
                         variant: 'danger',
                        solid: true
                      })

                  } else {

                    this.$bvToast.toast( response.data.message   , {
                        title: 'Ops , Something goes wrong',
                        variant: 'danger',
                        solid: true
                      })

                  }
                  this.loading = false;
              })
              .catch((error) => {
               
                this.$bvToast.toast( 'Error' , {
                        title: 'Ops , Something goes wrong',
                         variant: 'danger',
                        solid: true
                      })
                this.loading = false;
              }) 
               
            // })  
        }
    }

};
</script>

<style>
@import "../../assets/css/legacy.css";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");
#wrapper {
  font-family: "Poppins", sans-serif !important;

}
h3 {
  font-size: 21px;
}
.text-muted {
  color: #99abb4 !important;
}
.btn {
  padding: 8px 10px !important;
}
.btn-primary {
  background: #8950fc;
  border: 1px solid #8950fc;
}
</style>



// WEBPACK FOOTER //
// src/pages/Auth/Login.vue